export default __webpack_public_path__ + "static/media/2.1611e7f5.jpg";